export default function formatNewlines(text) {
    if (!text) return []
    return text.split(/\\n|\n/)
}
